import React from 'react';
import PropTypes from 'prop-types';
import {confirmable} from 'react-confirm';

import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap';

export const ConfirmModal = props => {
    const {
        okLabel,
        cancelLabel,
        title,
        message,
        show,
        proceed,
        dismiss,
        cancel,
        enableEscape,
    } = props;

    return (
        <Modal isOpen={show} toggle={dismiss} keyboard={enableEscape}>
            <ModalHeader toggle={dismiss}>{title}</ModalHeader>
            <ModalBody>{message}</ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={proceed}>{okLabel}</Button>{' '}
                <Button color="secondary" onClick={cancel}>{cancelLabel}</Button>
            </ModalFooter>
        </Modal>
    );
};

ConfirmModal.defaultProps = {
    okLabel: 'OK',
    cancelLabel: 'Cancel',
    enableEscape: true,
};

ConfirmModal.propTypes = {
    okLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string,
    show: PropTypes.bool,
    proceed: PropTypes.func,
    cancel: PropTypes.func,
    dismiss: PropTypes.func,
    enableEscape: PropTypes.bool,
};

export default confirmable(ConfirmModal);
